// File: my-spa/src/enums/day-of-week.enum.ts
// Esta definición debe ser IDÉNTICA a la del backend: backend-spa/src/employee-availability/enums/day-of-week.enum.ts
export enum DayOfWeek {
  LUNES = 'Lunes',
  MARTES = 'Martes', // <-- ¡Asegúrate de que sea 'Martes' sin 'ES' extra!
  MIERCOLES = 'Miércoles',
  JUEVES = 'Jueves',
  VIERNES = 'Viernes',
  SABADO = 'Sábado',
  DOMINGO = 'Domingo',
}
